module.exports = __webpack_public_path__ + "img/nt6-01-75-1.prt.4e288d4f.jpg";